import { QUESTIONS_ROUTES } from '../../constants/_routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// INDEX
const questions_csv_request = () => {
  return {
    type: questionsTypes.csv.request
  }
}

const questions_csv_success = () => {
  return {
    type: questionsTypes.csv.success
  }
}

const questions_csv_failure = (messages) => {
  return {
    type: questionsTypes.csv.failure,
    payload: messages
  }
}

const questions_xlsx = (filters={}, sort="", order="", variant="") => {
  return function (dispatch) {
    // Before Request
    dispatch(questions_csv_request())
    document.body.classList.add('instalevel-fetching-data')

    axios.get(
      `${QUESTIONS_ROUTES.index}.xlsx`,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters,
          variant: variant
        },
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const filename = (variant !== "") ? `questions_${variant}.xlsx` : 'questions.xlsx'
      const blob = URL.createObjectURL(response.data, "mitsos")
      let fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = filename
      fileLink.click();
      URL.revokeObjectURL(blob)
      dispatch( questions_csv_success() )
      document.body.classList.remove('instalevel-fetching-data')
    }).catch( error=> {
      // failure
      document.body.classList.remove('instalevel-fetching-data')
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching xlsx file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( questions_csv_failure(errors))
    })
  }

}

export {
  questions_xlsx
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/getxlsx.js